import './image-slider.scss';
class ImageSlider {

    constructor(element, options) {

        const settings = {
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, settings, options);

        this.$imageSlider = element;

        this.initialize();
    }

    initialize() {

        let $imageSliderClone = this.$imageSlider.cloneNode(true);

        import ('../../components/slider/slider').then(( { Slider }) => {

            const imageSlider = new Slider(this.$imageSlider, {
                effect: 'fade', 
                fullscreen: true, 
                speed: 500, 
                slidesPerView: 1, 
                slidesPerGroup: 1,
                initAttr: 'data-imageslider', 
                onFullscreen: (currentSlide) => {

                    let $fullscreenImageSlider = $imageSliderClone.cloneNode(true);

                    let $fullscreen = document.createElement('div');
                    $fullscreen.classList.add('site-fullscreen');

                    let $fullscreenSlides = $fullscreenImageSlider.querySelectorAll('[data-imageslider="slide"]');

                    for(let i = 0; i < $fullscreenSlides.length; i++) {
                        let $currentSlide = $fullscreenSlides[i];
                        let imageUri = $currentSlide.querySelector('[data-imageslider="fullscreen"]').getAttribute('data-zoom');

                        let $currentCaption;

                        if($currentSlide.querySelector('[data-imageslider="caption"]')) {
                            $currentCaption = $currentSlide.querySelector('[data-imageslider="caption"]').innerHTML;
                        }

                        let $fullscreenImage = document.createElement('figure');
                        $fullscreenImage.classList.add('fullscreen-image');

                        let $fullscreenImageWrap = document.createElement('span');
                        let $image = document.createElement('img');
                        $image.setAttribute('src', imageUri);

                        let $fullscreenCaption;
                        if($currentCaption) {
                            $fullscreenCaption = document.createElement('figcaption');
                            $fullscreenCaption.innerHTML = $currentCaption;

                            $fullscreenImage.appendChild($fullscreenCaption);
                        }

                        $fullscreenImageWrap.appendChild($image);

                        $fullscreenImage.appendChild($fullscreenImageWrap);
                        

                        $currentSlide.innerHTML = '';
                        $currentSlide.appendChild($fullscreenImage);
                    }

                    $fullscreen.appendChild($fullscreenImageSlider);

                    window.setTimeout(() => {
                        $fullscreen.classList.add('is--visible');
                    }, 150);

                    document.querySelector('body').appendChild($fullscreen);

                    new Slider($fullscreenImageSlider, {
                        effect: 'fade', 
                        fullscreen: true, 
                        speed: 500, 
                        slidesPerView: 1, 
                        slidesPerGroup: 1, 
                        initAttr: 'data-imageslider', 
                        initialSlide: currentSlide, 
                        onSlidePrev: () => {
                            imageSlider.sliderPrev();
                        }, 
                        onSlideNext: () => {
                            imageSlider.sliderNext();
                        }, 
                        onFullscreen: () => {

                            $fullscreen.classList.remove('is--visible');

                            window.setTimeout(() => {
                                $fullscreen.parentNode.removeChild($fullscreen);
                            }, 500);
                        }
                    });
                }
            });
        });
    }
}

export { ImageSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const context = eventDetails.$context;

    if (context) {
        const $$imageSlider = context.querySelectorAll('[data-imageslider="root"]');
        for (let i = 0; i < $$imageSlider.length; i++) {

            const $imageSlider = $$imageSlider[i];

            const imageSliderAPI = new ImageSlider($imageSlider);
            $imageSlider.imageSliderAPI = imageSliderAPI;
        }
    }
});
